var _react_refresh_temp_1;
var _react_refresh_temp_2;
_react_refresh_temp_2 = $RefreshSig$();
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useAppSelector } from '../../../../store';
import Avatar from './avatar';
import { participantsSelector } from '../../../../store/slices/participantSlice';
const Message = ({ body, currentUser }) => {
    _react_refresh_temp_2();
    const participant = useAppSelector((state) => participantsSelector.selectById(state, body.from.userId));
    const { t } = useTranslation();
    const render = () => {
        if (body.from.userId === 'system') {
            return (_jsx("div", { className: "content w-[calc(100%)] pt-2 system mb-2", children: _jsx("p", { className: "message-content max-w-fit shadow-footer text-xs bg-primaryColor text-white", dangerouslySetInnerHTML: { __html: body.msg } }) }));
        }
        else if ((currentUser === null || currentUser === void 0 ? void 0 : currentUser.userId) === body.from.userId) {
            return (_jsxs("div", { className: "content me w-[calc(100%-2rem)] pt-2", children: [_jsx("p", { className: "name pl-2 text-sm pb-1 primaryColor dark:text-darkText", children: t('right-panel.you') }), _jsx("p", { className: "message-content max-w-fit shadow-footer text-xs bg-secondaryColor text-white", dangerouslySetInnerHTML: { __html: body.msg } })] }));
        }
        else {
            return (_jsxs(_Fragment, { children: [_jsx(Avatar, { participant: participant, from: body.from }), _jsxs("div", { className: "content w-[calc(100%-2rem)] pt-2", children: [_jsxs("p", { className: "name pl-2 text-sm pb-1 dark:text-darkText", children: [body.from.name ? body.from.name : participant === null || participant === void 0 ? void 0 : participant.name, _jsx("span", { style: { fontSize: '10px' }, children: participant ? null : ' (offline)' })] }), _jsx("p", { className: "message-content max-w-fit bg-white shadow-footer text-xs", dangerouslySetInnerHTML: { __html: body.msg } })] })] }));
        }
    };
    return _jsx("div", { className: "wrapper flex ", children: render() });
};
_react_refresh_temp_1 = Message;
$RefreshReg$(_react_refresh_temp_1, "Message");
_react_refresh_temp_2(Message, "HmaIZPzoIBnwbVSIcuvyGd1iwy8=", false, () => [useAppSelector, useTranslation]);
export default Message;
